module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAOhJREFUOI3NlEFywjAMRb8Ch5DTTY6gJOwxR+lJTG6Sm9TsO4yPQDfBp6i6yMAkA07qDcNf2Zb0LMkaA6+UyM6u+WyWAY1jU3oQKjZlz2wQ4/WUmUXjRBo3O6tbTWVXZNEBnzKkQUQWKOZlqHrgd//MPdkj5o8fkDpmU8V4PYnsLAh9COdDFijG4cJsKhBZNmUPQgWlzxiHS7KKtxJNNyKNG5sMuxqpegzh3D2A7hClLoRvv8QYG68Oqn4KG411q/8pIRVT3G9YGLYF+duk5052UtvJ2krdfmXGWwAdMGv2+lfxTGsPk60/f0FItaRHz7UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliZiwo.png
// module id = yHB4
// module chunks = 1